import { render, staticRenderFns } from "./paymentMethod.vue?vue&type=template&id=6d4a86e6&scoped=true"
import script from "./paymentMethod.vue?vue&type=script&lang=js"
export * from "./paymentMethod.vue?vue&type=script&lang=js"
import style0 from "./paymentMethod.vue?vue&type=style&index=0&id=6d4a86e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a86e6",
  null
  
)

export default component.exports